BaseModel = require './base_model.coffee'

class global.Business extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    domain: {}
    status: {}
    address: {}
    list_contacts: {}
    contacts_count: {}
    human_status: {}
    stage: {}
    human_stage: {}
  }

  @ASSOCIATIONS = {
    tags: -> Tag
  }

  @SERIALIZABLE_ATTRIBUTES = [
    'id'
    'name'
    'domain'
    'address'
  ]



// WEBPACK FOOTER //
// ./src/models/business.coffee